export const keys = (listSize: number): number[] =>
  [...new Array(listSize)].map((item, index) => index);
